/** The in-button working indicator. Drawn in the button's own text color
 * (`currentColor`) so it stays visible in every state the button passes
 * through — soil on cantelope at rest, cantelope on soil under the
 * pointer, soil on the outline buttons — and sized to be seen at a glance. */
export default function ButtonSpinner() {
  return (
    <span
      aria-hidden="true"
      className="inline-block h-5 w-5 shrink-0 animate-spin rounded-full border-[3px] border-current border-r-transparent"
    />
  );
}
